<template>
  <div class="ad-container">
    <div class="padding-lr-16">
      <div>
        <h4>
        </h4>
        <div class="titleTwo text-12 text-grey">全部以电子发票进行开具</div>
      </div>
    </div>
    <div class="flex bg-title distance">
      <van-image
        width="1rem"
        height="1rem"
        fit="contain"
        class="notice margin-left-10"
        :src="require('assets/images/kfp/notice.png')"
      />
      <p class="text-12 text-primary margin-left-10">由滇约出行为您开具</p>
    </div>
    <div class="padding-lr-16">
      <p>发票详情</p>
      <div class="ad-body-box">
        <div class="flex justify-between">
          <p>发票类型</p>
          <p>电子发票</p>
        </div>
        <div class="flex justify-between">
          <p>抬头类型</p>
          <p>
            <van-radio-group
              v-model="fillFrom.titleType"
              @change="titleChange"
              class="flex justify-between"
            >
              <van-radio name="0">企业单位</van-radio>
              <van-radio name="1" style="margin-left: 16px"
                >个人/非企业</van-radio
              >
            </van-radio-group>
          </p>
        </div>
        <div class="flex justify-between">
          <p>发票抬头</p>
          <div class="flex justify-between">
            <van-field
              input-align="right"
              v-model="fillFrom.name"
              placeholder="请填写发票抬头"
            />
            <div @click="showPopup">
              <van-image
                width="2rem"
                height="1rem"
                fit="contain"
                class="list"
                :src="require('assets/images/kfp/list.png')"
              />
            </div>
          </div>
        </div>
        <van-cell-group v-if="fillFrom.titleType == 0">
          <van-field
            input-align="right"
            v-model="fillFrom.taxNumber"
            label="税号"
            placeholder="请填写公司税号"
            :rules="rules.taxNumber"
          />
        </van-cell-group>
        <div class="flex justify-between">
          <p>发票内容</p>
          <p>客运服务费</p>
        </div>
        <div class="flex justify-between">
          <p>发票金额</p>
          <p class="text-primary">{{ money }}</p>
        </div>
        <div class="flex justify-between" @click="moreInfo">
          <p>更多信息</p>
          <p>备注信息（非必填）></p>
        </div>
      </div>
    </div>
    <div class="padding-lr-16">
      <p>收件人信息（必填）</p>
      <div class="ad-body-box">
        <van-field
          v-model="fillFrom.recipient"
          name="收件人"
          label="收件人"
          required
          placeholder="收件人"
          :rules="rules.recipient"
          input-align="right"
        />
        <van-field
          v-model="fillFrom.phone"
          required
          name="pattern"
          label="手机号码"
          placeholder="手机号码"
          input-align="right"
          :rules="rules.phone"
        />
        <van-field
          v-model="fillFrom.email"
          name="邮箱地址"
          label="邮箱地址"
          required
          placeholder="邮箱地址"
          input-align="right"
          :rules="rules.email"
        />
      </div>
      <van-button class="button" type="warning" @click="verify()"
        >提交电子发票</van-button
      >
    </div>
    <van-popup
      v-model="show"
      closeable
      close-icon="close"
      close-icon-position="top-left"
      round
      position="bottom"
      :style="{ height: '54%' }"
    >
      <div>
        <div style="height: 320px; overflow: auto">
          <div v-if="list.length !== 0">
            <van-radio-group v-model="result" ref="checkboxGroup">
              <div class="distance-select">
                <van-radio
                  class="margin-top-20"
                  v-for="items in list"
                  :key="items.id"
                  :name="items.id"
                  @click="selectContent(items)"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    position: relative;
                  "
                >
                  <div>{{ items.headerName }}</div>
                  <div>{{ items.taxNumber }}</div>
                  <div @click="deLete(items.id)">
                    <van-image
                      width="2rem"
                      height="2rem"
                      fit="contain"
                      :src="require('assets/images/kfp/sc.png')"
                      style="position: absolute; right: 0; top: -3px"
                    />
                  </div>
                </van-radio>
              </div>
            </van-radio-group>
          </div>
          <div v-else>
            <van-image
              width="12rem"
              height="10rem"
              fit="contain"
              class="noUpimg"
              :src="require('assets/images/kfp/noUp.png')"
            />
            <div class="noUptext">您还没有常用抬头，马上添加吧</div>
          </div>
        </div>
        <div class="fix_btn">
          <van-button class="btnTwo" @click="$router.push('/invoice/addTitle')"
            >添加常用发票抬头</van-button
          >
        </div>
      </div>
    </van-popup>
    <!-- 更多信息 -->
    <van-popup
      v-model="showTwo"
      position="bottom"
      close-icon="close"
      close-icon-position="top-left"
      round
      closeable
      :style="{ height: '54%' }"
    >
      <div class="distance-select">
        <div class="infotitle text-14 bg-title margin-top-24">更多信息</div>
        <div>
          <van-cell-group>
            <!-- <van-field
              input-align="right"
              v-model="getUpDetail.address"
              label="注册地址"
              placeholder="填写注册地址"
            /> -->
            <!-- <van-field
              input-align="right"
              v-model="getUpDetail.mobile"
              label="注册电话"
              placeholder="填写注册电话"
            /> -->
            <van-field
              input-align="right"
              v-model="getUpDetail.openBank"
              label="开户银行"
              placeholder="填写开户银行"
            />
            <van-field
              input-align="right"
              v-model="getUpDetail.openBankNumber"
              label="银行账号"
              placeholder="填写银行账号"
            />
            <van-field
              input-align="right"
              v-model="getUpDetail.remark"
              label="备注说明"
              placeholder="填写备注说明"
            />
          </van-cell-group>
        </div>
        <van-button class="button btn" @click="downLoade">确认</van-button>
      </div>
    </van-popup>
    <!-- 确认信息 -->
    <van-popup
      v-model="showThree"
      position="bottom"
      round
      closeable
      :style="{ height: '70%' }"
      close-icon="close"
    >
      <div class="distance-select">
        <div class="infotitle text-14 bg-title margin-top-20">开票信息确认</div>
        <p>主要信息</p>
        <div class="ad-body-box">
          <div class="flex justify-between">
            <p>发票抬头</p>
            <p>{{ fillFrom.name }}</p>
          </div>
          <div v-if="fillFrom.titleType == 0" class="flex justify-between">
            <p>税号</p>
            <p>{{ fillFrom.taxNumber }}</p>
          </div>
          <div class="flex justify-between">
            <p>电子邮箱</p>
            <p>{{ fillFrom.email }}</p>
          </div>
        </div>
        <p>注意事项</p>
        <div class="ad-body-box">
          <div class="infotitle text-grey1">
            <p>请确认邮箱无误，电子发票将在系统开具后发送至你的邮箱</p>
          </div>
        </div>
        <van-button class="button btn" @click="submit">确认</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
// deleteUp
import { lookList, applyInvoice, getUpDetail, deleteUp } from 'api/invoice'
import { log } from 'util';

export default {
  name: 'InvoiceSubmitpage',
  data (options) {
    console.log(options)
    return {
      defaultHeight: '0', // 默认屏幕高度
      nowHeight: '0', // 实时屏幕高度
      id: '',
      all: options.$route.params.all,
      money: options.$route.params.money,
      showThree: false,
      showTwo: false,
      list: [],
      result: [],
      getUpDetail: {
        remark: ''
      },
      fillFrom: {
        name: '',
        titleType: '0',
        recipient: '',
        phone: '',
        email: '',
        taxNumber: ''
      },
      rules: {
        taxNumber: [
          {
            message: '税号格式错误',
            trigger: 'onBlur'
          }
        ],
        recipient: [
          {
            required: true,
            message: '请输入收件人',
            trigger: 'onBlur'
          }
        ],
        phone: [
          {
            pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/,
            message: '请输入正确的手机号码',
            trigger: 'onBlur'
          }
        ],
        email: [
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'onBlur'
          }
        ]
      },
      checked: true,
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      radio: '1',
      input: '',
      show: false
    }
  },

  activated () {
    const { all, money } = this.$route.params
    if (all) {
      this.all = this.$route.params.all
    }
    if (money) {
      this.money = this.$route.params.money
    }
  },
  methods: {
    //企业类型切换
    titleChange() {
        console.log("切换");
        console.log(this.fillFrom);
        this.fillFrom.name = '';
        this.fillFrom.phone = '';
        this.fillFrom.recipient = '';
        this.fillFrom.taxNumber = '';
    },
    confirmInfo () {
      this.showThree = true
    },
    downLoade () {
      this.showTwo = false
    },
    // 表单验证
    verify () {
      // const taxNumber = /^([159Y]{1})([1239]{1})([0-9ABCDEFGHJKLMNPQRTUWXY]{6})([0-9ABCDEFGHJKLMNPQRTUWXY]{9})([0-90-9ABCDEFGHJKLMNPQRTUWXY])$/
      const phoneVerigy = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
      const emailVerigy = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      console.log(this.fillFrom);

      if(this.fillFrom.titleType == 0){
         if (this.fillFrom.taxNumber == '') {
           this.$toast('税号不能为空')
        }
      }
      if (this.fillFrom.recipient == '') {
        this.$toast('请输入收件人')
      } else if (!this.fillFrom.phone.match(phoneVerigy)) {
        this.$toast('请输入正确手机号')
      } else if (!this.fillFrom.email.match(emailVerigy)) {
        this.$toast('请输入正确邮箱')
      } else {
        this.confirmInfo()
      }
    },
    // 调用删除接口
    deLete (val) {
      this.id = val
      this.$dialog
        .confirm({
          title: '提示',
          message: '是否确认删除该发票抬头'
        })
        .then(() => {
          this.deleteUp()
        })
        .catch(() => {})
    },
    deleteUp () {
      var data = {
        id: this.id
      }
      deleteUp(data)
        .then(res => {
          this.show = false
          this.showPopup()
          this.upDetail = this.list[0]
          window.localStorage.setItem(
            'upDetailId',
            JSON.stringify(this.upDetail)
          )
          this.fillFrom.name = this.upDetail.headerName
          this.fillFrom.taxNumber = this.upDetail.taxNumber
          this.$toast('删除成功')
        })
        .catch(() => {})
        .finally(() => {})
    },
    moreInfo () {
      this.showTwo = true
      var data = {
        id: this.upDetail.id
      }
      getUpDetail(data)
        .then(res => {
          const remark = this.getUpDetail.remark
          this.getUpDetail = {
            ...res,
            remark
          }
        })
        .catch(() => {})
        .finally(() => {})
    },
    selectContent (val) {
      this.upDetail = val
      console.log(val)
      console.log(this.upDetail)
      this.fillFrom.name = this.upDetail.headerName
      this.fillFrom.taxNumber = this.upDetail.taxNumber
      this.show = false
    },
    showPopup () {
      var data = {
        invoiceType: this.fillFrom.titleType
      }
      lookList(data)
        .then(res => {
          this.list = res
          this.show = true
        })
        .catch(() => {})
        .finally(() => {})
    },
    submit () {
      var orderDetails = JSON.parse(window.localStorage.getItem('detail'))
      var _orderDetails = []
      for (var i in orderDetails) {
        var _data = orderDetails[i]
        var _item = {}
        _item.name = _data.lineName
        _item.sn = _data.orderId
        _item.priceIncludingTax = _data.realPayMoney
        _orderDetails.push(_item)
      }
      var data = {
        titleType: this.fillFrom.titleType,
        name: this.fillFrom.name,
        taxNumber: this.fillFrom.taxNumber,
        email: this.fillFrom.email,
        content: '客运服务费 ',
        issueType: 0,
        remark: this.getUpDetail.remark,
        address: this.getUpDetail.address,
        mobile: this.getUpDetail.mobile,
        openBank: this.getUpDetail.openBank,
        openBankNumber: this.getUpDetail.openBankNumber,
        orderDetails: _orderDetails
      }
      applyInvoice(data)
        .then(res => {
          this.applyInvoice = res
          this.showThree = false
          this.$router.push('/invoice/progress')
        })
        .catch(() => {})
        .finally(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.ad-body-box {
  background-color: #fff;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 0 12px 0 #eee;
  padding: 0 8px;
}
.titleTwo {
  margin-top: -14px;
}
.notice {
  margin-top: 16px;
}
.bg-title {
  background-color: #fbd3926b;
  width: 100%;
}
.distance {
  margin-top: 20px;
}
.list {
  margin-top: 17px;
}
.button {
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  width: 80%;
  border-radius: 20px;
  margin: 50px 0px 5px 0px;
  background-color: #ff7307;
}
.fix_btn {
  width: 100%;
  height: 80px;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btnTwo {
  width: 90%;
  border-radius: 20px;
  background-color: #ff7307;
  color: #fff;
}
.btn {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  width: 80%;
  border-radius: 20px;
  margin: 10px 0;
  background-color: #ff7307;
  color: #fff;
}
.distance-select {
  padding: 24px;
}
.infotitle {
  padding: 8px;
}
.noUpimg {
  position: absolute;
  left: 52%;
  top: 50%;
  margin-left: -100px;
  margin-top: -120px;
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  opacity: 0.5;
}
.noUptext {
  position: absolute;
  left: 23%;
  top: 58%;
}
.focusState {
  position: absolute;
}
</style>
